import axios from "axios";

const state = {
  userToken: "",
  initSearch: "",
  isLogged: false,
  connectUserID: "",
  connectUserEmail: "",
  idEntreprise: null,
  idPlateforme: null,
  iframeColidee: false,
  authorizedPreview: false
};

const mutations = {
  IS_LOGGED(state, payload) {
    state.isLogged = true;
  },
  SET_TOKEN_URL(state, payload) {
    state.userToken = payload;
  },
  SET_SEARCH_URL(state, payload) {
    state.initSearch = payload;
  },
  SET_CONNECT_USER_ID(state, payload) {
    state.connectUserID = payload;
  },
  SET_CONNECT_USER_EMAIL(state, payload) {
    state.connectUserEmail = payload;
  },
  SET_ID_ENTREPRISE(state, payload) {
    if (payload === null) {
      state.idEntreprise = null;
    } else state.idEntreprise = Number(payload);
  },
  SET_ID_PLATEFORME(state, payload) {
    if (payload === null) {
      state.idPlateforme = null;
    } else state.idPlateforme = Number(payload);
  },
  SET_IFRAME_COLIDEE(state, payload) {
    state.iframeColidee = payload;
  },
  SET_AUTHORIZED_PREVIEW (state, payload) {
    state.authorizedPreview = payload
  }
};

const actions = {
  setIframeColidee({ commit }, payload) {
    commit("SET_IFRAME_COLIDEE", payload);
  },
  setTokenURL({ commit }, payload) {
    commit("SET_TOKEN_URL", payload.tokenURL);
  },
  setIdEntrepriseIdPlateforme({ commit }, payload) {
    commit("SET_ID_ENTREPRISE", payload.idEntreprise);
    commit("SET_ID_PLATEFORME", payload.idPlateforme);
  },
  setInitSearch({ commit }, payload) {
    commit("SET_SEARCH_URL", payload.initSearch);
  },
  requireAuth({ commit }, payload) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.getters.userToken;
    axios
      .get(process.env.URL_SSO_API + "user/me")
      .then(response => {
        commit("IS_LOGGED");
        commit("SET_CONNECT_USER_ID", response.data.id);
        commit("SET_CONNECT_USER_EMAIL", response.data.email);
        window.location = "/admin";
      })
      .catch(error => {
        window.location = process.env.URL_SSO_FRONT;
      });
  }
};

const getters = {
  userToken: state => state.userToken,
  isLogged: state => state.isLogged,
  idEntreprise: state => state.idEntreprise,
  idPlateforme: state => state.idPlateforme,
  currentUserEmail: state => state.connectUserEmail,
  iframeColidee: state => state.iframeColidee,
  authorizedPreview: state => state.authorizedPreview
};

const authentificationModule = {
  state,
  mutations,
  actions,
  getters
};

export default authentificationModule;



// WEBPACK FOOTER //
// ./src/store/modules/authentification/index.js